import { render, staticRenderFns } from "./sites.vue?vue&type=template&id=2cf05e7c&scoped=true"
import script from "./sites.vue?vue&type=script&lang=js"
export * from "./sites.vue?vue&type=script&lang=js"
import style0 from "./sites.vue?vue&type=style&index=0&id=2cf05e7c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf05e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf05e7c')) {
      api.createRecord('2cf05e7c', component.options)
    } else {
      api.reload('2cf05e7c', component.options)
    }
    module.hot.accept("./sites.vue?vue&type=template&id=2cf05e7c&scoped=true", function () {
      api.rerender('2cf05e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/sites.vue"
export default component.exports